import React from 'react';
import { Skeleton } from 'components/_shared/Skeleton';
import { Button } from 'components/_shared/Button';
import { getAccountToday } from 'utils';
import { formatShortDay, formatCoverage } from '../../fields.utils';
import {
  Section,
  Head,
  Row,
  Day,
  Machine,
  LateTag,
  Percent,
  Empty,
  RetryRow
} from './PassList.styles';

const arrivedDay = (pass, timezone) =>
  getAccountToday(timezone, new Date(pass.arrived_at));

export const PassList = ({ survey, passes, timezone, isLoading, isError, onRetry }) => {
  const body = () => {
    if (isLoading) return <Skeleton height='60px' />;
    if (isError) {
      return (
        <RetryRow>
          <span>Failed to load.</span>
          <Button onClick={onRetry}>Retry</Button>
        </RetryRow>
      );
    }
    if (!passes?.length) {
      return (
        <Empty>
          <b>No passes yet.</b> This survey opened {formatShortDay(survey.opened_on)} and
          is waiting for the next machine to run this field. Coverage starts accumulating
          the moment one does.
        </Empty>
      );
    }
    return passes.map(pass => (
      <Row key={pass.id} $late={pass.arrived_late}>
        <Day>{formatShortDay(pass.observed_on)}</Day>
        <Machine>
          {pass.serial}
          {pass.arrived_late && (
            <LateTag>arrived {formatShortDay(arrivedDay(pass, timezone))}</LateTag>
          )}
        </Machine>
        <Percent>
          {pass.covered_ratio == null ? '—' : formatCoverage(pass.covered_ratio)}
        </Percent>
      </Row>
    ));
  };

  return (
    <Section data-testid='pass-list'>
      <Head>
        Passes in this survey
        <span>every run a unit sent us, newest last</span>
      </Head>
      {body()}
    </Section>
  );
};
